var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"common-nav-link",attrs:{"href":_vm.url,"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleClick($event)}}},[_vm._t("default",[_vm._v("LINK")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }